const clean = (value) => String(value || '').trim();

export const resolveChatWorkspaceContext = ({ search = '', incident = null } = {}) => {
  const params = new URLSearchParams(search);
  const scenarioId = clean(params.get('sid') || incident?.scenario_id);
  const isScenario = (
    params.get('scenario') === '1'
    || params.has('sid')
    || incident?.is_scenario === true
  );

  return {
    isScenario,
    scenarioId,
    workspaceLabel: isScenario ? 'Scenario' : 'Incident',
    chatLabel: isScenario ? 'Scenario Chat' : 'Incident Chat',
    participantLabel: isScenario ? 'Scenario Participants' : 'Active Responders',
  };
};

export const shouldFetchChatIncidentDetail = ({
  incidentId = '',
  search = '',
  incidentFromStore = null,
} = {}) => {
  if (!clean(incidentId)) return false;
  const params = new URLSearchParams(search);
  const scenarioRouteRequested = params.get('scenario') === '1' || params.has('sid');
  return (
    !incidentFromStore
    || scenarioRouteRequested
    || incidentFromStore?.is_scenario === true
  );
};

const buildScenarioParams = ({ isScenario = false, scenarioId = '', messageId = '' } = {}) => {
  const params = new URLSearchParams();
  if (isScenario) {
    params.set('scenario', '1');
    if (clean(scenarioId)) params.set('sid', clean(scenarioId));
  }
  if (clean(messageId)) params.set('msg', clean(messageId));
  const query = params.toString();
  return query ? `?${query}` : '';
};

export const buildChatWorkspaceUrl = ({
  incidentId,
  isScenario = false,
  scenarioId = '',
  messageId = '',
} = {}) => (
  `/incident-details/${encodeURIComponent(clean(incidentId))}/chat${buildScenarioParams({
    isScenario,
    scenarioId,
    messageId,
  })}`
);

export const buildChatWorkspaceBackUrl = ({
  incidentId,
  isScenario = false,
  scenarioId = '',
} = {}) => (
  `/incident-details/${encodeURIComponent(clean(incidentId))}${buildScenarioParams({
    isScenario,
    scenarioId,
  })}`
);

export const scenarioAwareSystemChannel = (channel, isScenario = false) => {
  if (!isScenario || !channel?.system_key) return channel;
  if (channel.system_key === 'incident') {
    return {
      ...channel,
      name: 'Scenario Channel',
      description: 'Scenario planners, discussion members and web-managed additional members',
    };
  }
  if (channel.system_key === 'command') {
    return {
      ...channel,
      name: 'Scenario Planning Channel',
      description: 'Administrators and scenario planning members',
    };
  }
  return channel;
};
